import "./Notification.scss"

const Notification = () => {
  return (
     <div className="notification">
      <div className="notification-content">
        <span className="checkmark">✓</span>
        <p>Changes saved successfully!</p>
      </div>
    </div>
  )
}

export default Notification